import { parseTriggerForDisplay } from 'components/schedules/trigger-utils'

export default function NextScheduled({ trigger }) {
  const next = parseTriggerForDisplay(trigger)
  const scheduled =
    trigger.type === 'Random' ? `${next.start} to ${next.end}` : next.time
  return `Scheduled: ${scheduled}`
}
